"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementCommand = exports.RemoveElementCommand = exports.AddElementCommand = void 0;
const zod_1 = require("zod");
const schema_1 = require("../../part/schema");
const vector_1 = require("../../vector");
const common_1 = require("./common");
/**
 * Add a single element to the document.
 */
exports.AddElementCommand = zod_1.z.object({
    type: zod_1.z.literal(common_1.CommandType.addElementCommand),
    /**
     * Uid of the element
     */
    elementUid: zod_1.z.string(),
    /**
     * The exact part and part version that should be used when creating this
     * element.
     */
    partDescriptor: schema_1.StaticPartVersionDescriptorSchema,
    /**
     * OPTIONAL position on the schematic that the element should be added at.
     */
    position: zod_1.z.optional(zod_1.z.union([vector_1.StoredSchematicPosition2, zod_1.z.record(vector_1.StoredSchematicPosition2)])),
});
/**
 * Remove one
 */
exports.RemoveElementCommand = zod_1.z.object({
    type: zod_1.z.literal(common_1.CommandType.removeElementCommand),
    elementUid: zod_1.z.string(),
});
/**
 * An command that can be performed on a document to modify
 * its element collection.
 */
exports.ElementCommand = zod_1.z.discriminatedUnion("type", [exports.AddElementCommand, exports.RemoveElementCommand]);
//# sourceMappingURL=elements.js.map